import React from 'react';
import { useAppSelector } from '../../data/store';
import ProductPriceFormat from '../../../../products/product-price/product-price-format';

const SubscriptionOverviewItem = () => {

    const cartData = useAppSelector(store => store.root.cartData);
    const daysText = cartData?.subscription?.numberOfFreeDays === 1 ? 'day' : 'days';
    const hasCoupons = cartData.redeemedCoupons.length > 0;

    return (
        cartData.subscription ?
            <div className="text-gray-500 flex items-end justify-between mb-4">
                <div>
                    <div>{ cartData.subscription.numberOfFreeDays } { daysText } free</div>
                    <div>
                        Future <span>{ cartData.subscription.sbsPeriod }</span> payments
                    </div>
                    { hasCoupons && <div>Not including the discounts below</div> }
                </div>
                <div className="font-bold"><ProductPriceFormat price={ cartData.subscription.futureMonthlyPayments } /></div>
            </div>:
            <></>
    )
};

export default SubscriptionOverviewItem;